import * as React from 'react';
import MuiCheckbox, {CheckboxProps} from 'original/Checkbox/Checkbox';
export * from 'original/Checkbox/Checkbox';
import {createStyles, makeStyles} from '../styles';
import clsx from 'clsx';

const useStyles = makeStyles(
  createStyles({
    readOnly: {
      pointerEvents: 'none',
    },
  })
);

const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(({className, ...props}: CheckboxProps, ref) => {
  const {readOnly} = useStyles();
  return <MuiCheckbox ref={ref} className={clsx(className, {[readOnly]: props.readOnly})} {...props} />;
});

export default Checkbox;
